import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStopAtStation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M20.0005 3V12C20.0005 12.71 19.6205 13.36 19.0005 13.72V15.25C19.0005 15.66 18.6605 16 18.2505 16H17.7505C17.3405 16 17.0005 15.66 17.0005 15.25V14H10.0005V15.25C10.0005 15.66 9.66051 16 9.25051 16H8.75051C8.34051 16 8.00051 15.66 8.00051 15.25V13.72C7.39051 13.36 7.00051 12.71 7.00051 12V3C7.00051 0 10.0005 0 13.5005 0C17.0005 0 20.0005 0 20.0005 3ZM11.0005 11C11.0005 10.45 10.5505 10 10.0005 10C9.45051 10 9.00051 10.45 9.00051 11C9.00051 11.55 9.45051 12 10.0005 12C10.5505 12 11.0005 11.55 11.0005 11ZM18.0005 11C18.0005 10.45 17.5505 10 17.0005 10C16.4505 10 16.0005 10.45 16.0005 11C16.0005 11.55 16.4505 12 17.0005 12C17.5505 12 18.0005 11.55 18.0005 11ZM18.0005 3H9.00051V7H18.0005V3ZM5.00051 5.5C4.97051 4.12 3.83051 3 2.45051 3.05C2.12219 3.0565 1.79836 3.12762 1.49753 3.2593C1.1967 3.39098 0.924755 3.58064 0.697238 3.81744C0.469722 4.05425 0.291088 4.33355 0.171542 4.63941C0.051995 4.94527 -0.0061222 5.27168 0.000509932 5.6C0.01357 6.1672 0.218403 6.71324 0.581609 7.14908C0.944816 7.58493 1.44497 7.88487 2.00051 8V16H3.00051V8C4.18051 7.76 5.00051 6.71 5.00051 5.5Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgStopAtStation);
export { ForwardRef as ReactComponent };
